import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const Post = (path, data, token) => {
    return Axios({
        method: 'POST',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
}

export default Post;